import request from '@/utils/request'
//认证接口
export function authenticationApi(data) {
    return request({
      url:'/api/ros-user-service/api/authentication/add',
      method: 'post',
      data
    })
  }
//认证详情
export function authenticationdetailApi(data) {
    return request({
      url:'/api/ros-user-service/api/authentication/info',
      method: 'post',
      data
    })
  }
  //系统首页我的项目
  export function getMyProjectApi() {
    return request({
      url:'/api/ros-developer-service/system/homepage/my/project/list',
      method: 'get',
      
    })
  }
  //系统首页我的详情
  export function getMyInfoApi() {
    return request({
      url:'/api/ros-user-service/api/user/info',
      method: 'get',
      
    })
  }
  //用户系统通知分页列表
  export function getUserNoticeList(params) {
    return request({
      url:'/api/ros-user-service/api/user/notice/my/notice/page',
      method: 'get',
      params
    })
  }
  //用户通知详情
  export function getUserNoticeDetail(userNoticeId) {
    return request({
      url:`/api/ros-user-service/api/user/notice/my/notice/info/${userNoticeId}`,
      method: 'get',
    })
  }
  //用户通知全部已读
  export function markReadAll() {
    return request({
      url:`/api/ros-user-service/api/user/notice/my/mark/read/all`,
      method: 'post',
    })
  }
  //用户通知未读数量
  export function unRead() {
    return request({
      url:`/api/ros-user-service/api/user/notice/my/unread/count`,
      method: 'get',
    })
  }
  //系统通知分页列表
  export function getSysNotice() {
    return request({
      url:'/api/ros-developer-service/system/homepage/notice/list',
      method: 'get',
      
    })
  }
  //系统通知分页列表
  export function getSysNoticeList(params) {
    return request({
      url:'/api/ros-developer-service/system/homepage/notice/page',
      method: 'get',
      params
    })
  }
  //系统通知分页列表
  export function getSysNoticeDetail(params) {
    return request({
      url:'/api/ros-developer-service/system/homepage/notice/detail',
      method: 'get',
      params
    })
  }
  //支持与服务
  export function getSupport(params) {
    return request({
      url:'/api/ros-developer-service/system/homepage/support/index',
      method: 'get',
      params
    })
  }
  //修改我的项目名称
  export function modifyProjectName(data) {
    return request({
      url:'/api/ros-developer-service/system/homepage/modify/my/project/name',
      method: 'post',
      data
      
    })
  }
  //查询项目产品资料
  export function getProjectdeatil(data) {
    return request({
      url:'/api/ros-developer-service/system/homepage/my/project/device/document/detail',
      method: 'get',
      params:data
      
    })
  }
  //查询项目开发文档
  export function getProjectDoc(data) {
    return request({
      url:'/api/ros-developer-service/system/homepage/project/development/document/list',
      method: 'get',
      params:data
      
    })
  }
  //发送邮箱验证码
  export function sendEmailCode(data) {
    return request({
      url:'/api/ros-user-service/api/user/send/email/code',
      method: 'post',
      data
      
    })
  }
  //绑定邮箱
  export function bindEmail(data) {
    return request({
      url:'/api/ros-user-service/api/user/bind/email',
      method: 'post',
      data
      
    })
  }
  //修改密码
  export function modifySecret(data) {
    return request({
      url:'/api/ros-user-service/api/user/modify/password',
      method: 'post',
      data
      
    })
  }
